import Emitter from '../core/Emitter';

class WidgetProperty extends Emitter {
	constructor() {
		super();
	}

	validate() {
		return this.validator(this.model);
	}

	commitValue(value) {
		this._setModel(this.formatter(value));
		let e = new Event('commit');
		e.detail = this.model;
		this.dispatchEvent(e);
	}

	parser(model) {
		return model;
	}

	formatter(model) {
		return model;
	}

	validator(model) {
		return true;
	}

	_setColumns(value) {
		this._columns = value;

		let e = new Event('columnsChanged');
		e.detail = value;
		this.dispatchEvent(e);
	}

	get columns() {
		return this._columns;
	}

	_setModel(value) {
		this._model = value;

		let e = new Event('changed');
		e.detail = value;
		this.dispatchEvent(e);
	}

	get model() {
		return this._model;
	}
}

export default WidgetProperty;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetProperty.js